export default __webpack_public_path__ + "static/media/580.e78889a0.jpg";